import { BackendWebSocketService } from './BackendWebSocketService';
import { GenesysWebSocketService } from './GenesysWebSocketService';
import { useAuthStore } from '@/stores/auth';
import { useMessageStore } from '@/stores/messages';

/**
 * Coordinates the integration between Genesys WebSocket and Backend WebSocket
 * Handles connection sequence, message synchronization, and edge cases
 */
export const IntegrationCoordinator = {
  isInitialized: false,

  /**
   * Initialize both WebSocket connections in the correct order
   */
  async initialize(): Promise<boolean> {
    const authStore = useAuthStore();
    const messageStore = useMessageStore();

    try {
      // Step 1: Connect to backend first to check session status
      const backendConnected = await BackendWebSocketService.connect();

      if (!backendConnected) {
        console.warn('Backend connection failed, continuing with Genesys only');
      }

      // Step 2: Connect to Genesys WebSocket
      await GenesysWebSocketService.connect();

      // Step 3: Load conversation history
      if (authStore.conversationId) {
        await GenesysWebSocketService.loadConversationHistory(
          authStore.conversationId
        );

        // Step 4: Send any new messages to backend if connected
        if (backendConnected) {
          await BackendWebSocketService.sendNewMessages(messageStore.messages);
        }
      }

      this.isInitialized = true;
      return true;
    } catch (error) {
      console.error('Failed to initialize integration:', error);
      return false;
    }
  },

  /**
   * Cleanup when component unmounts
   */
  cleanup(): void {
    GenesysWebSocketService.disconnect();
    BackendWebSocketService.disconnect();
    this.isInitialized = false;
  },
};
